import React, { Component } from "react";
import { connect } from 'react-redux';
import AuthService from "../../service/AuthService";
import { successLoginAction, logoutAction, AuthenticationState } from "../../reducer/authentication";
import { loadingAction } from "../../reducer/loading";
import { RouteChildrenProps } from "react-router-dom";
import { RootState } from "../../reducer";
import logoBackgrounf from '../../images/logo_commbox_transparent_full.png';
import {
    Button,
    FormControl,
    FormHelperText,
    IconButton,
    InputAdornment,
    Paper,
    TextField,
    Theme
} from "@mui/material";
import logo from '../../images/logo_safedesk.png';
import { withSnackbar, WithSnackbarProps } from "notistack";
import UserApi from "../../service/UserApi";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Trans, withTranslate } from "../../components/Translate";
import { WithTranslateProps } from "../../components/Translate/withTranslate";
import { WithTheme, withTheme } from "@mui/styles";

interface ChangePasswordPageProps extends AuthenticationState, RouteChildrenProps, WithSnackbarProps, WithTranslateProps, WithTheme<Theme> {
    successLoginAction: typeof successLoginAction;
    logoutAction: typeof logoutAction;
    loadingAction: typeof loadingAction;
}

interface ChangePasswordPageState {
    isValidToken: boolean,
    password: string,
    confirmPassword: string,
    errorMessage: string,
    token: string,
    visiblePassword: boolean,
    visibleConfirmPassword: boolean
}

class ChangePasswordPage extends Component<ChangePasswordPageProps, ChangePasswordPageState> {

    private serviceAuthUser: UserApi;

    constructor(props: ChangePasswordPageProps) {
        super(props);
        this.state = {
            password: '',
            confirmPassword: '',
            token: '',
            errorMessage: '',
            isValidToken: false,
            visiblePassword: false,
            visibleConfirmPassword: false
        }
        this.serviceAuthUser = new UserApi();
        this.onSubmitHandler = this.onSubmitHandler.bind(this);
        this.onPasswordChangeHandler = this.onPasswordChangeHandler.bind(this);
        this.onConfirmPasswordChangeHandler = this.onConfirmPasswordChangeHandler.bind(this);
        this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
        this.handleClickShowConfirmPassword = this.handleClickShowConfirmPassword.bind(this);
    }

    async validateToken() {
        var { history, location, enqueueSnackbar, t } = this.props;
        const params = new URLSearchParams(location.search);
        var token = params.get('token');
        var validate = false;
        if (token) {
            validate = await this.serviceAuthUser.validateToken(token);
        }

        if (!validate) {
            enqueueSnackbar(t('invalidToken', { capitalize: true, namespace: 'changePassword' }), { variant: 'error', autoHideDuration: 5000 });
            history.push('/');
        } else {
            this.setState({ isValidToken: true, token: token || '' });
        }
    }

    async componentDidMount() {
        await this.validateToken();
        await this.logoutUser();
    }

    async logoutUser() {
        const { loadingAction, logoutAction } = this.props;
        await AuthService.instance.logout();
        logoutAction();
    }

    onPasswordChangeHandler(ev: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            password: ev.target.value,
            errorMessage: ''
        });
    }

    onConfirmPasswordChangeHandler(ev: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            confirmPassword: ev.target.value,
            errorMessage: ''
        });
    }

    handleClickShowPassword() {
        const { visiblePassword } = this.state;
        this.setState({
            visiblePassword: !visiblePassword
        });
    }

    handleClickShowConfirmPassword() {
        const { visibleConfirmPassword } = this.state;
        this.setState({
            visibleConfirmPassword: !visibleConfirmPassword
        });
    }

    async onSubmitHandler(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        var { history, location, enqueueSnackbar, t } = this.props;
        const { password, token, isValidToken, confirmPassword } = this.state;

        if (password !== confirmPassword) {
            this.setState({ errorMessage: t('passwordsMustMatch', { capitalize: true, namespace: 'changePassword' }) });
            return;
        }

        if (password.trim().length < 8) {
            this.setState({ errorMessage: t('passwordMustBeAtLeastCharactersLong', { capitalize: true, namespace: 'changePassword' }) });
            return;
        }

        if (token === '' || !isValidToken) {
            enqueueSnackbar(t('invalidToken', { capitalize: true, namespace: 'changePassword' }), { variant: 'error', autoHideDuration: 5000 });
            history.push('/');
            return;
        }

        const result = await this.serviceAuthUser.setPassword({ password: password.trim(), token: token });
        if (result) {
            enqueueSnackbar('Senha atualizada com sucesso.', { variant: 'success', autoHideDuration: 5000 });
        } else {
            enqueueSnackbar('Erro ao atualizar senha.', { variant: 'error', autoHideDuration: 5000 });
        }
        history.push('/');
    }

    render() {
        const { theme, t } = this.props;
        const { password, isValidToken, errorMessage, confirmPassword, visiblePassword, visibleConfirmPassword } = this.state;
        const margin = theme.spacing(3);
        if (!isValidToken) return '';
        return (
            <div style={{ display: 'flex', flexDirection: 'column', backgroundSize: 'cover', alignContent: 'center', justifyContent: 'center', alignItems: 'center', placeContent: 'center', flexGrow: 1, backgroundImage: `url(${logoBackgrounf})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center center' }}>
                <Paper style={{ width: 400, padding: margin, display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', paddingBottom: margin }}>
                        <img src={logo} alt="Logo" style={{ height: 60 }} />
                    </div>
                    <form onSubmit={this.onSubmitHandler} style={{ display: 'flex', flexDirection: 'column' }}>
                        <TextField
                            variant="standard"
                            label={'Nova senha'}
                            onChange={this.onPasswordChangeHandler}
                            value={password}
                            type={visiblePassword ? 'text' : 'password'}
                            style={{ paddingBottom: margin }}
                            autoComplete='off'
                            required
                            InputProps={{ // <-- This is where the toggle button is added.
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton tabIndex={-1} onClick={this.handleClickShowPassword} size="large">
                                            {visiblePassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }} />
                        <TextField
                            variant="standard"
                            label={'Confirmar nova senha'}
                            onChange={this.onConfirmPasswordChangeHandler}
                            value={confirmPassword}
                            type={visibleConfirmPassword ? 'text' : 'password'}
                            style={{ paddingBottom: margin }}
                            autoComplete='off'
                            required
                            InputProps={{ // <-- This is where the toggle button is added.
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton tabIndex={-1} onClick={this.handleClickShowConfirmPassword} size="large">
                                            {visibleConfirmPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }} />
                        <FormControl variant="standard">
                            <Button type="submit" variant='contained' color='primary'>
                                Salvar
                            </Button>
                        </FormControl>
                    </form>
                    {errorMessage && <FormHelperText error={true}>{errorMessage}</FormHelperText>}
                </Paper>
            </div>
        );
    }
}

function mapStateToProps(state: RootState) {
    const { authentication } = state;
    return authentication;
}

const mapDispatchToProps = {
    loadingAction,
    successLoginAction,
    logoutAction
};

const WithThemeComp = withTheme<Theme, typeof ChangePasswordPage>(ChangePasswordPage);
const WithTranslateComp = withTranslate<ChangePasswordPageProps>()(WithThemeComp);
const WithSnackbar = withSnackbar(WithTranslateComp);
const connected = connect(mapStateToProps, mapDispatchToProps)(WithSnackbar);
export default connected;